import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { UsersAddComponent } from "./users-add/users-add.component";
import { UsersDetailsComponent } from "./users-details/users-details.component";
import { UsersEditComponent } from "./users-edit/users-edit.component";

const usersRoutes: Routes = [
    { path: "users/:cnpj/new", component: UsersAddComponent },
    { path: "users/:cnpj/:uid", component: UsersDetailsComponent },
    { path: "users/:cnpj/:uid/edit", component: UsersEditComponent },
];

@NgModule({
    imports: [RouterModule.forChild(usersRoutes)],
    exports: [RouterModule],
})
export class UsersRoutingModule {}
